export default __webpack_public_path__ + "static/media/midasi_point_ko_pc@2x.4635809d.png";